<footer class="footer footer-dark" [ngStyle]="getColor()">
 <div class="footer-middle">
  <div class="container">
   <div class="col-sm-12 newWidth">
    <div class="widget widget-about">
     <p class="ADULT-USE">
      <b style="text-transform: uppercase" tabindex="0">
       * For use only by adults 21 years of age and older. Keep out of reach of children and pets. In case of accidental ingestion or overconsumption, contact the Poison hotline 1-800-222-1222 or call 9-1-1. Please consume responsibly. Cannabis can be addictive. Concerned about your cannabis use? Contact the New York State HOPELine by texting “HopeNY”, calling 1-877-8-HOPENY, or visiting
       <a style="color: #000000 !important" href="https://oasas.ny.gov/HOPELine" target="_blank">oasas.ny.gov/HOPELine</a>
       .
      </b>
     </p>
    </div>
   </div>
   <div class="row">
    <div class="col-sm-6 col-lg-3 newWidth">
     <div class="widget widget-about">
      <img src="{{ siteDada?.footerLogo?.url }}" class="footer-logo" alt="Highlife Health Logo" />
      <p class="max-lines-heading" tabindex="0" role="text" aria-label="Footer Text">
       <b>{{ footerContent?.heading }}</b>
      </p>
      <p class="max-lines" [innerHTML]="footerContent?.text" tabindex="0" style="color: white; font-size: 1rem"></p>
     </div>
    </div>

    <div class="col-sm-6 col-lg-3 newWidth1">
     <div class="widget footer-link-side">
      <h2 class="widget-title" tabindex="0">Useful Links</h2>
      <ul class="widget-list">
       <li *ngFor="let item of usefulLinks">
        <a href="javascript:;" tabindex="0" routerLink="{{ item?.link }}">{{ item?.name }}</a>
       </li>
      </ul>
      <h2 class="widget-title" style="margin-top: 30px; margin-bottom: 10px" tabindex="0">Get In Touch</h2>
      <ul class="Socila-edia-footer">
       <li *ngIf="siteDada?.instagramLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.instagramLink }}" rel="noopener noreferrer" tabindex="0" aria-label="Instagram" target="_blank">
         <img src="assets/images/instagram.png" alt="instagram" class="insta" />
        </a>
       </li>
       <li *ngIf="siteDada?.facebookLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.facebookLink }}" rel="noopener noreferrer" tabindex="0" aria-label="Facebook" target="_blank">
         <img src="assets\images\facebook.png" alt="facebook" class="insta" />
        </a>
       </li>

       <li *ngIf="siteDada?.twitterLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.twitterLink }}" target="_blank" tabindex="0" rel="noopener noreferrer" aria-label="Twitter">
         <img src="assets/images/twitter.png" alt="twitter" class="insta" />
        </a>
       </li>

       <li *ngIf="siteDada?.youtubeLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.youtubeLink }}" target="_blank" rel="noopener noreferrer" tabindex="0" aria-label="Youtube">
         <img src="assets/images/youtube.png" alt="youtube" class="insta" />
        </a>
       </li>

       <li *ngIf="siteDada?.linkdinLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.linkdinLink }}" target="_blank" rel="noopener noreferrer" tabindex="0" aria-label="Linkedin">
         <img src="assets/images/linkedin.png" alt="Linkedin" class="insta" />
        </a>
       </li>

       <li *ngIf="siteDada?.snapchatLink != ''" style="margin-top: 10px">
        <a href="{{ siteDada?.snapchatLink }}" target="_blank" rel="noopener noreferrer" tabindex="0" aria-label="Snapchat">
         <img src="assets/images/snapchat.png" alt="snapchat" class="insta" />
        </a>
       </li>
      </ul>
     </div>
    </div>

    <div class="col-sm-6 col-lg-3 newWidth1">
     <div class="widget footer-link-side">
      <h2 class="widget-title" tabindex="0">Contact Information</h2>

      <ul class="widget-list">
       <li>
        <img src="assets/images/place.png" class="loca-img-new" alt="Location details icon" />
        <span tabindex="0" role="text">{{ storeInfo?.Address?.AddressLine2 }}</span>
       </li>
       <li>
        <a [href]="'tel:' + getStoreMObile()" tabindex="0" [attr.aria-label]="'Call the store at ' + generatePhoneNumber() + '. Initiates a phone call.'">
         {{ generatePhoneNumber() }}
        </a>
       </li>
       <li>
        <a [href]="'mailto:' + siteDada?.supportmail" aria-describedby="email-note">
         {{ siteDada?.supportmail }}
        </a>

        <span id="email-note" class="visually-hidden">Activating this link will open your default email application.</span>
       </li>
       <li>
        <img src="assets/images/footerImg.png" class="authorizedImg" alt="Licensed Cannabis Dispensary" />
       </li>
      </ul>
     </div>
    </div>

    <div class="col-sm-6 col-lg-3 newWidth1">
     <div class="widget footer-link-side">
      <h2 class="widget-title" tabindex="0">My Account</h2>
      <ul class="widget-list" style="margin-bottom: 25px">
       <li *ngIf="!auth">
        <a style="cursor: pointer">
         <a tabindex="0" routerLink="/login">Sign In/</a>
         <a tabindex="0" routerLink="/register">Register</a>
        </a>
       </li>
       <li *ngIf="auth"><a tabindex="0" routerLink="/dashboard/profile">Dashboard</a></li>
       <li *ngIf="auth"><a tabindex="0" (click)="openLogoutPopUp()" (keydown.enter)="openLogoutPopUp()" style="cursor: pointer">Sign Out</a></li>
      </ul>
      <h2 class="widget-title" style="margin-bottom: 10px" tabindex="0">Hours of operations</h2>
      <p class="max-lines" style="color: white; font-size: 15px" tabindex="0">Open Today : {{ checkDeliveryDay() }}</p>
     </div>

     <h4 class="widget-title mt-1 mb-1">App Download</h4>

     <ul>
      <li>
       <div class="app-links">
        <a href="https://apps.apple.com/us/app/highlife-dispensary/id6749842027" target="_blank" target="_blank">
         <img src="assets/images/ios.png" alt="Download on App Store" style="width: 120px !important" />
        </a>

        <a href="https://play.google.com/store/apps/details?id=com.highlife.health" target="_blank">
         <img src="assets/images/playstore.png" alt="Get it on Google Play" style="width: 120px !important; height: 40px !important; border: 0.1px solid rgb(155 154 154); border-radius: 6px" />
        </a>
       </div>
      </li>
     </ul>
    </div>
   </div>
  </div>
 </div>

 <div class="footer-bottom">
  <div class="container">
   <div class="row align-items-center" style="width: 100%">
    <div class="col-md-4">
     <p class="footer-copyright" tabindex="0">
      Powered by

      <a href="https://www.cannalogic.com/" target="_blank" tabindex="0" aria-describedby="cannalogic-description">
       <img src="assets/images/cannalogic.png" alt="cannalogic logo" class="cannalogic-logo" />
      </a>
      <span id="cannalogic-description" style="display: none">Cannalogic is a cannabis software solution.</span>
     </p>
    </div>
    <div class="col-md-4">
     <div style="display: flex">
      <p class="Licenseno">
       <a *ngIf="siteDada?.license" style="font-size: 13px" tabindex="0">
        {{ siteDada?.licenseHeading }}
        <br />
        {{ siteDada?.license }}
       </a>
      </p>
     </div>
    </div>
    <div class="col-md-4">
     <p class="footer-copyright right">
      <span tabindex="0">{{ siteDada?.copyrightText }}</span>
      <br />
      <a href="javascript:;" routerLink="/privacypolicy" tabindex="0">Privacy Policy</a>
      &nbsp;&nbsp;/&nbsp;&nbsp;
      <a href="javascript:;" routerLink="/termsandcondition" tabindex="0">Terms and Conditions</a>
     </p>
    </div>
   </div>
  </div>
 </div>
</footer>
